/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { ColorAlias } from "../../theme";
import { PropostaProviders } from "../../graphql/__GENERATED__/types";
import Typography from "../Typography";
import MapfreLogo from "./mapfreLogo";
import SompoLogo from "./sompoLogo";
import SwissreLogo from "./swissreLogo";
import AllianzLogo from "./allianzLogo";
import BtgLogo from "./btgLogo";
import FairfaxLogo from "./fairfaxLogo";
import PortoLogo from "./portoLogo";
import EssorLogo from "./essorLogo";
import TokyoMarineLogo from "./tokyoMarineLogo";
import SancorLogo from "./sancorLogo";

interface ProviderLogoProps {
  provider: PropostaProviders;
  color?: ColorAlias;
  onClick?: () => void;
}

const ProviderLogo: FC<ProviderLogoProps> = ({ provider, color, onClick }) => {
  if (provider === PropostaProviders.Mapfre) {
    return <MapfreLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Sompo) {
    return <SompoLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Swiss) {
    return <SwissreLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Allianz) {
    return <AllianzLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Btg) {
    return <BtgLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Fairfax) {
    return <FairfaxLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Porto) {
    return <PortoLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Essor) {
    return <EssorLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Tokyo) {
    return <TokyoMarineLogo onClick={onClick} color={color} />;
  }
  if (provider === PropostaProviders.Sancor) {
    return <SancorLogo onClick={onClick} color={color} />;
  }

  return (
    <Typography variant="textLarge" uppercase color={color} weight="bold">
      {provider}
    </Typography>
  );
};

export default ProviderLogo;
